import * as P from "parsimmon";
const whitespace = P.optWhitespace;
const Var = P.regex(/[a-zA-Z_-][a-zA-Z0-9_.-]*/).map((name) => name);
const Op = P.alt(P.string(":"), P.string("@"), P.string("#"), P.string(">"), P.string("<"));
// Var Op Var
const Statement = P.seqMap(Var.skip(whitespace), Op.skip(whitespace), Var.skip(whitespace), (left, op, right) => {
    switch (op) {
        case ":":
            return [{ objectName: left, stateName: right }];
        case "@":
            return [{ objectName: left, positionObjectName: right }];
        case "#":
            return [];
        case ">":
            return [{ objectName: right, parentObjectName: left }];
        case "<":
            return [{ objectName: left, parentObjectName: right }];
    }
});
// ( Expression )
const BracketedExpression = P.lazy(() => P.string("(")
    .skip(whitespace)
    .then(Condition)
    .skip(P.string(")").skip(whitespace)));
// Statement or ( Expression )
const Expression = P.lazy(() => P.alt(NotExpr, Statement, BracketedExpression));
// !Expression
const NotExpr = P.lazy(() => P.string("!").trim(whitespace).then(Expression).map(expr => expr));
// a & b & c
const AndExpr = P.lazy(() => P.sepBy1(Expression, P.string("&").trim(whitespace)).map(terms => terms.reduce((left, right) => [...left, ...right])));
// a & b | c & d | ...
const OrExpr = P.lazy(() => P.sepBy1(AndExpr, P.string("|").trim(whitespace)).map(terms => terms.reduce((left, right) => [...left, ...right])));
const Condition = OrExpr;
export const PreConditionStateParser = Condition.skip(P.eof);
